<mat-grid-list cols="12" gutterSize="24px">
<mat-toolbar class="header">
  <button mat-flat-button color="primary" class="menu" (click)="sideNavOpened = !sideNavOpened; accordion.closeAll();"><mat-icon>menu</mat-icon> Menu</button>

  <span class="logoFrame">
    <a [href]="logoRoute" title="Navigate to Huron Consulting Group Home">
      <img src="assets/huron-white.svg" alt="Huron Consulting Group Logo" class="logo" />
    </a>
    <a [routerLink]="['/']" title="Navigate to {{configService.appSettings.applicationName}} Home" class="title">
				{{ configService.appSettings.applicationName }}</a>
  </span>
  <ng-content select="[header-content]"></ng-content>
  <nav class="user-nav">
    <span class="brandingName">{{ user?.brandingName }} </span>
    <span class="divider">|</span>
    <span class="name">{{user?.firstName}} {{user?.lastName}}</span>
    <notifications *ngIf="showNotificationIcon" [user]="user"></notifications>
    <button mat-flat-button [routerLink]="['/logout']" aria-label="Log out">Log out</button>
  </nav>
</mat-toolbar>
</mat-grid-list>

<mat-sidenav-container class="huron-sidenav">
  <mat-sidenav [opened]="sideNavOpened" mode="side" [class.sideNavClosed]="!sideNavOpened">
    <div class="expand-button">
      <button mat-icon-button (click)="sideNavOpened = !sideNavOpened; accordion.closeAll();" aria-label="toggle menu">
        <mat-icon mat-list-icon *ngIf="!sideNavOpened" >chevron_right</mat-icon>
        <mat-icon mat-list-icon *ngIf="sideNavOpened" >chevron_left</mat-icon>
      </button>
    </div>

    <mat-nav-list>
      <mat-accordion multi="false">
        <ng-container *ngFor="let item of sideNavItems">
          <nav-item [item]="item" [(sideNavOpened)]="sideNavOpened" [user]="user" [accordion]="accordion"></nav-item>
        </ng-container>
      </mat-accordion>
    </mat-nav-list>
    <ng-content select="[left-nav-content]"></ng-content>
  </mat-sidenav>

  <mat-sidenav-content [class.close]="!sideNavOpened">
    <main [ngClass]="{'loading': isLoading}">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>

<mat-toolbar role="contentinfo" class="footer">
  <p>© {{currentYear}} Huron Consulting Group Inc. and affiliates. All rights reserved.</p>
</mat-toolbar>
